import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button, ButtonGroup, Menu, MenuItem, Tooltip } from '@mui/material';
import { Track, TrackBuyProvider, TrackVendor } from 'models/Track';
import { TrackRequest, TrackRequestType } from 'models/TrackRequest';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { openExternal } from 'utils/openExternal';

export interface TrackBuyActionMenuProps {
  request: TrackRequest;
  onClick?: () => void;
}

export function TrackBuyActionMenu(props: TrackBuyActionMenuProps) {
  const { t } = useTranslation();
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | Element>(null);
  const openMenu = Boolean(menuAnchorEl);

  const handleOpenMenu = (ev: React.MouseEvent<Element>) => {
    ev.preventDefault();
    setMenuAnchorEl(ev.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
  };

  const handleBuyTrack = (provider: TrackBuyProvider) => {
    let searchQuery: string | null = null;

    if (
      props.request.type === TrackRequestType.Track ||
      props.request.type === TrackRequestType.Library
    ) {
      const { artist, title } = props.request.value as Track;
      searchQuery = `${artist} ${title}`;
    } else if (props.request.type === TrackRequestType.String) {
      searchQuery = props.request.value as string;
    }

    if (searchQuery) {
      const encodedSearchQuery = encodeURIComponent(searchQuery);

      switch (provider) {
        case TrackBuyProvider.Beatport:
          openExternal(`https://www.beatport.com/search?q=${encodedSearchQuery}`);
          break;
        case TrackBuyProvider.DjCity:
          openExternal(`https://www.djcity.com/search-overview?q=${encodedSearchQuery}`);
          break;
        case TrackBuyProvider.Apple:
          if ((props.request.value as Track)?.vendor == TrackVendor.Apple) {
            openExternal(`${(props.request.value as Track)?.vendorUrl}&app=itunes`);
          } else {
            openExternal(`https://music.apple.com/de/search?term=${encodedSearchQuery}`);
          }
          break;
        default:
          openExternal(`https://music.apple.com/search?term=${encodedSearchQuery}`);
          break;
      }

      // if (props.request.type === RequestType.Track) {
      //   const { artist, title } = props.request.value as ITrack;
      //   const searchQuery = `${artist} ${title}`;
      //   const encodedSearchQuery = encodeURIComponent(searchQuery);
      //   const appleMusicsearchUrl = `https://music.apple.com/search?term=${encodedSearchQuery}`;
      //   // console.info(appleMusicsearchUrl);
      //   // console.info((request.value as ITrack).vendorUrl);
      //   // console.info(request.value as ITrack);
      //   //window.open(appleMusicsearchUrl, "_blank");
      //   //window.open((request.value as ITrack)?.vendorUrl ?? appleMusicsearchUrl, "_blank");
      //   openExternal(
      //     null !== ((props.request.value as ITrack)?.vendorUrl) && '' !== ((props.request.value as ITrack)?.vendorUrl)
      //       ? `${(props.request.value as ITrack)?.vendorUrl}&app=itunes` ?? ''
      //       : appleMusicsearchUrl
      //   );
      // } else {
      //   // Redirect to Apple Music homepage if the request is not a track
      //   const appleMusicsearchUrl = `https://music.apple.com/search?term=${props.request.value as string}`;
      //   console.info(appleMusicsearchUrl);
      //   //window.open(appleMusicsearchUrl, "_blank");
      //   openExternal(appleMusicsearchUrl);
      // }
    }

    props.onClick?.();
    handleCloseMenu();
  };

  return (
    <>
      <ButtonGroup variant="contained" size="small" color="primary">
        <Tooltip title={t('buyOnAppleMusic', 'Buy on Apple Music')}>
          <Button onClick={() => handleBuyTrack(TrackBuyProvider.Apple)}>{t('buy', 'Buy')}</Button>
        </Tooltip>
        <Button
          aria-controls={openMenu ? 'split-button-menu' : undefined}
          aria-expanded={openMenu ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleOpenMenu}
          style={{ minWidth: '1.5rem' }}
          sx={{ px: 0 }}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Menu
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
        anchorEl={menuAnchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
      >
        <MenuItem onClick={() => handleBuyTrack(TrackBuyProvider.Apple)}>
          {t('buyOnAppleMusic', 'Buy on Apple Music')}
        </MenuItem>
        <MenuItem onClick={() => handleBuyTrack(TrackBuyProvider.Beatport)}>
          {t('buyOnBeatport', 'Buy on Beatport')}
        </MenuItem>
        <MenuItem onClick={() => handleBuyTrack(TrackBuyProvider.DjCity)}>
          {t('buyOnDjcity', 'Buy on DJcity')}
        </MenuItem>
      </Menu>
    </>
  );
}
